import PropTypes from 'prop-types';
import React from 'react';

import IfmsButton, { IfmsButtonProps } from './IfmsButton';

const GrayButtonTabs = React.forwardRef<HTMLButtonElement, IfmsButtonProps>(({children, ...other}, ref) => {
  return (
    <IfmsButton ref={ref} {...other} baseClass="ifms-gray-tab-button ifms-button-tabs">
      {children}
    </IfmsButton>
  );
});

GrayButtonTabs.defaultProps = {
};

GrayButtonTabs.propTypes = {
  size: PropTypes.oneOf(['regular', 'small', 'large']),
};

export default React.memo(GrayButtonTabs);

